// English Translation
export default {
  // Navigation
  navHome: 'Home',
  navMethod: 'TSMC Method',
  navServices: 'Services',
  navAbout: 'About Us',
  navFaq: 'FAQ',
  navContact: 'Contact & Booking',
  navBlog: 'BLOG',
  
  // Buttons
  bookNow: 'Book Now',
  lineConsult: 'LINE Consult',
  bookNowFull: 'Book Now',
  
  // Hero
  heroTitle1: 'Engineer\'s Precision',
  heroTitle2: 'Restore Body Structure',
  heroSubtitle: 'Tainan Jiali Professional Chiropractic & Sports Massage',
  heroDesc: 'Integrating Top Techniques from USA, Japan, Australia, Canada | Deep Fascia Release | Structural Mechanics',
  heroCert: 'Multi-National Certified',
  heroPrice: 'Transparent Pricing',
  heroTime: 'Open Sat-Wed',
  
  // What is Chiropractic
  whatIsTitle: 'What is',
  whatIsChiro: 'Chiropractic',
  whatIsSubtitle: "Chiropractic schools and manual traditions",
  whatIsPara1: "In some international systems, ",
  whatIsChiroFull: "Chiropractic",
  whatIsPara1b: " is a manual tradition that originated in the United States and was founded by ",
  whatIsFounder: 'Daniel David Palmer',
  whatIsPara1c: " in 1895. The following describes that school’s perspective.",
  whatIsPara2: "Within that tradition, specific manual methods are used to consider joint movement and whole-body use, ",
  whatIsRestore: "with adjustments guided by personal comfort",
  whatIsPara2b: "; this is not a disease diagnosis, medical treatment, or guarantee of a specific result.",
  whatIsBoxTitle: "Understanding daily body use as a whole",
  whatIsBoxDesc: "This approach considers daily loading, movement habits, and how different areas work together:",
  whatIsCycle1: "Repeated demands from work or exercise",
  whatIsCycle2: "Muscle tension and movement habits can influence each other",
  whatIsCycle3: "Different areas coordinate and compensate during movement",
  whatIsCycle4: "Look at everyday body use from a whole-body perspective",
  chiroCardTitle: 'Chiropractic',
  chiroCardDesc: 'Specializing in',
  chiroCardFocus: 'skeletal adjustments',
  chiroCardDesc2: ', restoring normal joint mobility through precise techniques',
  massageCardTitle: 'Sports Massage',
  massageCardDesc: 'Specializing in',
  massageCardFocus: 'muscle relaxation',
  massageCardDesc2: ', releasing deep fascia tension and improving muscle imbalance',
  whatIsSummary: 'TSMC integrates both approaches',
  whatIsSummary2: ', identifying which system is causing the problem and applying appropriate techniques, analyzing the overall "cause" and "prevention" based on mechanics and structure',
  
  // TSMC Method
  methodTitle: 'TSMC',
  methodTitleSuffix: 'Method',
  methodSubtitle: 'TSMC\'s Unique Body Structure Adjustment System',
  methodT: 'Technology',
  methodTSub: 'Multi-National Technique Integration',
  methodTDesc: 'Integrating top chiropractic techniques from USA, Japan, Australia, Canada for comprehensive care',
  methodS: 'Stretching',
  methodSSub: 'Stretching & Structural Adjustment',
  methodSDesc: 'Systematically improving body structural imbalance from spine, pelvis to limb joints',
  methodM: 'Mobility',
  methodMSub: 'Mobility Optimization',
  methodMDesc: 'Targeting deep muscles and fascia to enhance joint range of motion and flexibility',
  methodC: 'Chiro',
  methodCSub: 'Customized Chiropractic',
  methodCDesc: 'Designing personalized care plans based on individual constitution, symptoms, and lifestyle',
  methodSystemTitle: 'The Body is a Precision Biomechanical System',
  methodSystem1: 'Bones connect muscles, muscles pull bones',
  methodSystem2: 'Muscles exert force, supporting bones, bones support the entire body',
  methodSystem3: 'Resisting gravity and responding to various forces in life',
  
  // Services
  services: 'Professional Services',
  servicesDesc: 'Dual-Track Care - Chiropractic + Sports Massage',
  chiro: 'Chiropractic',
  chiroService: "Specific manual methods · Daily movement care · Body awareness",
  chiroFeature1: "Manual methods adjusted to personal comfort",
  chiroFeature2: "Consider everyday movement and body-use habits",
  chiroFeature3: "Daily care for seated, standing, and physical-work lifestyles",
  chiroPrice: '$1000',
  chiroPriceSuffix: 'up / 30-40 min',
  massage: 'Chiropractic + Sports Massage',
  massageService: "Manual care · Deep fascial relaxation · Post-exercise care",
  massageFeature1: "Deep muscle and fascial relaxation based on personal needs",
  massageFeature2: "Post-exercise relaxation for regularly active people",
  massageFeature3: "Whole-body relaxation for office and physical workers",
  massagePrice: '$2300',
  massagePriceSuffix: '/ 90 min',
  suitable: 'Suitable for:',
  chiroSuitable: "office workers, standing workers, physical workers, and people who value daily body care",
  massageSuitable: "active people, office workers, physical workers, and those seeking post-exercise relaxation",
  
  // Services Summary
  servicesSummary1: "Two-track bodywork: manual care + massage",
  servicesSummary2: ", tailored to lifestyle and everyday relaxation needs",
  
  // Who Needs Our Services
  whoNeedsTitle: "Which lifestyles may suit daily body care?",
  whoNeedsSubtitle: "Grouped by lifestyle and everyday body use—not by disease diagnosis or treatment",
  
  // Target Groups
  targetOffice: "Desk & Office Group",
  targetOfficeSymptom1: "Long hours at a computer",
  targetOfficeSymptom2: "Lower daily activity",
  targetOfficeSymptom3: "Holding one position for long periods",
  targetOfficeSymptom4: "Seeking daily neck, shoulder, and back relaxation",
  
  targetAthlete: "Regularly Active Group",
  targetAthleteSymptom1: "Strength training or ball sports",
  targetAthleteSymptom2: "Seeking post-exercise relaxation",
  targetAthleteSymptom3: "Values stretching and daily care",
  targetAthleteSymptom4: "Wants to understand body-use habits",
  
  targetPosture: "Standing Work Group",
  targetPostureSymptom1: "Work requires long periods of standing",
  targetPostureSymptom2: "Frequent walking or fixed positions",
  targetPostureSymptom3: "High everyday use of the legs",
  targetPostureSymptom4: "Seeking leg and whole-body relaxation",
  
  targetChronic: "Physical Work Group",
  targetChronicSymptom1: "Frequently lifts or carries at work",
  targetChronicSymptom2: "Repeats similar movements for long periods",
  targetChronicSymptom3: "High everyday physical workload",
  targetChronicSymptom4: "Seeking whole-body muscle relaxation",
  
  targetSenior: "Mature Lifestyle Group",
  targetSeniorSymptom1: "Values daily movement and body care",
  targetSeniorSymptom2: "Prefers a gentle approach",
  targetSeniorSymptom3: "Wants pressure adjusted for comfort",
  targetSeniorSymptom4: "Schedules regular relaxation time",
  
  targetPregnant: "Regular Body-Care Group",
  targetPregnantSymptom1: "No specific disease-treatment need",
  targetPregnantSymptom2: "Values relaxation and self-care",
  targetPregnantSymptom3: "Wants to understand daily movement habits",
  targetPregnantSymptom4: "Schedules regular body-care sessions",
  
  // About Us
  aboutTitle: 'From Engineer to Bodyworker',
  aboutSubtitle: 'Philosophy and Approach',
  aboutPara1: 'The engineer\'s mindset is to pursue',
  aboutPara1Highlight: '"solving problems at the root"',
  aboutPara1b: '. Like debugging code, we don\'t just treat pain symptoms, we find the root cause of structural imbalances.',
  aboutPara2: 'Each adjustment is like recompiling the body\'s structural code. We combine top techniques from',
  aboutPara2Highlight: 'USA, Japan, Australia, and Canada',
  aboutPara2b: ', using engineer-level precision to provide the deepest optimization for your body.',
  aboutPara3: 'In Tainan Jiali, we offer more than traditional massage. We provide',
  aboutPara3Highlight: 'systematic body care',
  aboutPara3b: ' combining modern anatomy, biomechanics, and sports science.',
  aboutQuote: 'The body is a precision biomechanical system. What it needs is not temporary fixes, but systematic structural reconstruction. We use engineering logic combined with professional techniques to help every client restore optimal body condition.',
  aboutQuoteAuthor: '— TSMC Founder',
  
  // FAQ
  faqTitle: 'Frequently Asked Questions',
  faqSubtitle: 'About Tainan Jiali Chiropractic & Massage',
  
  // FAQ Q&A
  faq1Q: 'What\'s the difference between Chiropractic and traditional massage?',
  faq1A: 'Chiropractic focuses on "skeletal joint alignment", restoring normal joint mobility through precise techniques to fundamentally improve body mechanics. Traditional massage focuses on meridian clearing and muscle relaxation. TSMC combines both for comprehensive care.',
  
  faq2Q: 'Is it uncomfortable? Is it safe?',
  faq2A: 'Our techniques are professionally trained. You may feel mild stretching or pressure, but no pain. All operations are within safe limits and adjusted according to your condition.',
  
  faq3Q: 'How often should I come?',
  faq3A: 'It depends on individual conditions. For acute cases, 1-2 times per week is recommended. For chronic issues, more frequent sessions may be needed initially (once per week), then can be extended to once every 2-4 weeks for maintenance. We provide professional advice based on your situation.',
  
  faq4Q: 'What should I bring for my first visit?',
  faq4A: 'Wear loose, comfortable clothing. If you have had body examinations (X-rays, MRI, etc.), you may bring them for reference. We will conduct a detailed body assessment before creating a personalized care plan.',
  
  faq5Q: 'How do you charge?',
  faq5A: 'Chiropractic starts at $1000 (30-40 minutes), Chiropractic + Sports Massage $2300 (90 minutes). Pricing is transparent with no hidden fees. For first-timers, we recommend starting with Chiropractic so we can assess your condition and suggest suitable services.',
  
  faq6Q: 'Can I come from outside Tainan Jiali?',
  faq6A: 'Of course! We serve clients from all Tainan areas, including Jiali, Madou, Xuejia, Jiangjun, Qigu, Xigang, Anding, etc. Convenient transportation with Google Maps navigation.',
  
  // Reviews
  reviewsTitle: 'Real Customer Feedback',
  reviewsSubtitle: 'From Our Valued Customers with 5-Star Reviews',
  reviewsViewAll: 'View All Google Reviews',
  reviewsFrom: 'Source',
  
  // Training
  trainingTitle: 'International Training',
  trainingSubtitle: 'Continuous Professional Development',
  trainingIntro: 'Over the years, continuously learning from professional instructors worldwide, constantly improving technical expertise and bringing advanced chiropractic concepts back to Taiwan.',
  trainingYear: '',
  trainingStats1: 'Continuous Learning',
  trainingStats1Val: '10+ Years',
  trainingStats2: 'International Instructors',
  trainingStats2Val: '10+ Masters',
  trainingStats3: 'Cross-border Training',
  trainingStats3Val: 'Multiple Times',
  
  // CTA
  ctaTitle: "Ready to schedule daily body care?",
  ctaDesc: "Choose a non-medical bodywork service based on your lifestyle and relaxation needs",
  ctaBooking: 'Book Online',
  ctaLine: 'LINE Online Consultation',
  ctaTransparent: 'Transparent Pricing',
  ctaTransparentDesc: 'No Hidden Fees\nClear Pricing',
  ctaCert: 'Professionally Certified',
  ctaCertDesc: 'Multi-National\nTechniques',
  ctaFlex: 'Flexible Booking',
  ctaFlexDesc: 'Online System\nQuick & Easy',
  
  // Footer
  footerHours: 'Business Hours',
  footerHoursDays: 'Saturday to Wednesday',
  footerHoursTime: '11:00 AM - 9:40 PM',
  footerHoursClosed: 'Closed Thursday & Friday',
  footerLocation: 'Location',
  footerLocationCity: 'Jiali District, Tainan City',
  footerLocationAddr: 'No. 130-95, Anxi, Wenxin Village',
  footerLocationMap: 'Google Maps Navigation',
  footerLocationSearch: 'Open TSMC Chiro Studio directly on Google Maps',
  footerLocationGuide: 'No need to search the address. Tap the button below for direct navigation.',
  footerLocationOpenMap: 'Open Direct Google Maps Navigation',
  footerContact: 'Contact',
  footerContactLine: 'Official LINE Account',
  footerFollow: 'Follow Us',
  footerServices: 'Services',
  footerService1: 'Chiropractic',
  footerService2: 'Joint Mobility Improvement',
  footerService3: 'Sports Massage',
  footerService4: 'Deep Fascia Release',
  footerService5: 'Pelvis Adjustment',
  footerService6: 'Posture Assessment & Optimization',
  footerDisclaimer: 'Important Notice:',
  footerDisclaimerText: "TSMC provides non-medical traditional bodywork and sports massage for everyday relaxation, body care, and body awareness. We do not diagnose or treat disease and do not provide rehabilitation. For persistent pain, numbness, weakness, dizziness, acute injury, or other possible medical conditions, please consult a licensed physician first.",
  footerBookingBtn: '🎯 Book Online Now',
  footerCopyright: '© 2026 TSMC - Tainan Jiali Professional Chiropractic & Sports Massage Studio',
  footerTagline1: 'Technology of Stretching & Mobility Chiro',
  footerTagline2: 'Tainan Jiali · Professional Chiropractic & Sports Massage',

  
  // Service Flow
  serviceFlowTitle: 'Our Service Process',
  serviceFlowSubtitle: 'From professional assessment to precise adjustment, every step ensures optimal care',
  serviceFlowPhase1: 'Assessment Phase',
  serviceFlowPhase2: 'Adjustment Phase',
  serviceFlowScrollHint: 'Scroll to view complete process',
  step1Title: 'Individual Movement Observation',
  step1Desc: 'Selected movements are observed according to individual comfort to understand daily activity and body-use patterns',
  step2Title: 'Leg Length Assessment',
  step2Desc: 'Precise measurement of pelvic and lower limb length differences to identify structural imbalances',
  step3Title: 'Foot Examination',
  step3Desc: 'Check plantar pressure distribution and arch status to evaluate gait issues',
  step4Title: 'Pressure Testing',
  step4Desc: 'Assess muscle tension and joint mobility to confirm problem areas',
  step5Title: 'Back Adjustment',
  step5Desc: 'Deep myofascial release to improve back muscle tension imbalance',
  step6Title: 'Neck & Shoulder Adjustment',
  step6Desc: 'Precise adjustment for neck and shoulder stiffness to restore mobility',
  step7Title: 'Complete Check',
  step7Desc: 'Post-session re-evaluation to confirm improvement and provide follow-up recommendations'
};
